import { gql } from '@apollo/client';

export default gql`
  mutation createEvent(
    $branch: String
    $title: String
    $desc: String
    $prefix: String
    $docNo: String
    $rRule: String
    $startDate: Date
    $endDate: Date
    $showOnCal: Boolean
    $allDay: Boolean
    $reminder: Boolean
    $location: LocationInput
    $locationLink: String
    $address: String
    $houseno: String
    $priority: Int
    $amount: Float
    $status: Int
    $items: String
    $attachments: String
    $daction: Boolean
    $actions: String
    $bonos: Float
    $overtime: Float
    $absent: Boolean
    $cashin: Float
    $customer: CustomerInput
    $department: DepartmentInput
    $employee: EmployeeInput
    $project: ProjectInput
    $resourse: ResourseInput
    $contract: ContractInput
    $retype: RetypeInput
    $retype2: Retype2Input
    $extend: Boolean
  ) {
    createEvent(
      branch: $branch
      title: $title
      desc: $desc
      prefix: $prefix
      docNo: $docNo
      rRule: $rRule
      startDate: $startDate
      endDate: $endDate
      showOnCal: $showOnCal
      allDay: $allDay
      reminder: $reminder
      location: $location
      locationLink: $locationLink
      address: $address
      houseno: $houseno
      priority: $priority
      amount: $amount
      status: $status
      items: $items
      attachments: $attachments
      daction: $daction
      actions: $actions
      bonos: $bonos
      overtime: $overtime
      absent: $absent
      cashin: $cashin
      customer: $customer
      department: $department
      employee: $employee
      project: $project
      resourse: $resourse
      contract: $contract
      retype: $retype
      retype2: $retype2
      extend: $extend
    ) {
      _id
      id
      branch
      title
      startDate
      endDate
      duration
      allDay
      rRule
      exDate
      allowDrag

      autoNo
      docNo
      priority
      amount
      status

      bonos
      overtime
      absent
      cashin
      teamMembers
      groupId
      locationLink
      address
      houseno

      customerId
      customerName
      customerNameAr
      customerPhone

      itemId
      itemName
      itemNameAr

      departmentId
      departmentName
      departmentNameAr
      departmentColor

      employeeId
      employeeName
      employeeNameAr
      employeeColor
      employeePhone
      workersIds

      resourseId
      resourseName
      resourseNameAr
      resourseColor

      contractId
      contractName
      contractNameAr

      retypeId
      retypeName
      retypeNameAr
      retypeColor

      retype2Id
      retype2Name
      retype2NameAr
      retype2Color

      attachments

      userId
      createdAt
      updatedAt
    }
  }
`;
